import React from 'react';
import "../../../Styles/donationTypesComponent.css"
import { DONATION_TYPE_CONSTANTS } from '../../../constants';
import { DonationTypeRadioButton } from '../../../components';

export function DonationTypesComponent({donationType, updateDonationType}) {

    return <React.Fragment>
        <div>
            <ul id="donationTypeComponent">
                {
                    DONATION_TYPE_CONSTANTS.map((type) => {
                        return <DonationTypeRadioButton
                            key={type.value}
                            inputId={type.id}
                            listId={type.value == donationType ? "underLineSelectedOption" : null}
                            isOptionSelected={type.value == donationType}
                            donationTypeName={type.name}
                            donationTypeValue={type.value}
                            updateDonationType={updateDonationType}
                        />
                    })
                }
            </ul>
        </div>
    </React.Fragment>
}